export const commonTermsMock = {
  termsDocument: {
    name: 'Common Terms',
    pdfData:
      'https://test.resurs.com/documenthandler/Dokument.pdf?customerType=natural&docType=commonTerms&land=FI&language=fi',
  },
  termsResponseType: 'COMMON',
};

export const isekkiTerms = {
  termsDocument: {
    name: 'ISEKKI Terms',
    pdfData:
      'https://sekki-mock.integration.resurs.com/sekki?bankProductId=PART_PAY&chainId=6500&countryCode=FI&language=fi&storeId=6202&amount=4500',
  },
  termsResponseType: 'ISEKKI_NEW_ACCOUNT',
};
